import { combineReducers } from '@reduxjs/toolkit';
import categoriesReducer from './slices/categories.slice';
import crateMetricsReducer from './slices/crateMetrics.slice';
import djepTitleFormatSlice from './slices/djep-title-format.slice';
import dmsReducer from './slices/dms.slice';
import globalImportProgressReducer from './slices/global-import-progress.slice';
import lnrpReducer from './slices/lnrp.slice';
import loading from './slices/loading.slice';
import myCrateFolderFilterSlice from './slices/my-crate-folder-filter.slice';
import myCrateFolderSliceReducer from './slices/my-crate-folder.slice';
import PreferencesStateSlice from './slices/preferences-state.slice';
import preferences from './slices/preferences.slice';
import toast from './slices/toast.slice';
import user from './slices/user.slice';
import uiReducer from './slices/ui.slice';
import { AudioPlayerSlice } from './slices/audio-player-state.slice';
import { CrateSlice } from './slices/crate.slice';
import { DriveStateSlice } from './slices/drive-state.slice';
import { scanningSlice } from './slices/scanning.slice';
import { ThemeStateSlice } from './slices/theme-state.slice';
import { TokenStateSlice } from './slices/token-state.slice';
import { trackMatcherSlice } from './slices/track-matcher.slice';
import { TrackSlice } from './slices/track.slice';

export const rootReducer = combineReducers({
  themeState: ThemeStateSlice.reducer,
  tokenState: TokenStateSlice.reducer,
  driveState: DriveStateSlice.reducer,
  categories: categoriesReducer,
  crate: CrateSlice.reducer,
  track: TrackSlice.reducer,
  audioPlayerState: AudioPlayerSlice.reducer,
  trackMatcherState: trackMatcherSlice.reducer,
  PreferencesState: PreferencesStateSlice,
  toast,
  loading,
  user,
  lnrp: lnrpReducer,
  preferences,
  dms: dmsReducer,
  ui: uiReducer,
  djepTitleFormat: djepTitleFormatSlice.reducer,
  scanningState: scanningSlice.reducer,
  globalImportProgress: globalImportProgressReducer,
  crateMetrics: crateMetricsReducer,
  myCratesFolder: myCrateFolderSliceReducer,
  myCratesFolderFilter: myCrateFolderFilterSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
